import api from './api';

export interface ExpertInvitation {
  id: number;
  expertId: number;
  email: string;
  name: string | null;
  surname: string | null;
  token: string;
  status: 'pending' | 'accepted' | 'cancelled';
  createdAt: string;
  expiresAt: string;
}

export interface SendInvitationDto {
  email: string;
  name?: string;
  surname?: string;
}

class ExpertInvitationsService {
  async sendInvitation(dto: SendInvitationDto): Promise<{ id: number; email: string; expiresAt: string }> {
    const response = await api.post('/expert/invitations', dto);
    return response.data.data;
  }

  async getInvitations(): Promise<ExpertInvitation[]> {
    const response = await api.get('/expert/invitations');
    // Відповідь — масив без обгортки
    return Array.isArray(response.data) ? response.data : response.data.data ?? [];
  }

  async acceptByToken(token: string): Promise<{ success: boolean; message: string }> {
    const response = await api.get('/expert-invitations/accept', { params: { token } });
    return response.data;
  }
}

export const expertInvitationsService = new ExpertInvitationsService();
